import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["cache"];
import { parseAsEstreeExpression } from "./parse";
import { precook } from "./precook";
var ASTCache = new Map();
// `raw` should always be asserted by `isEvaluable`.
export function preevaluate(raw) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    {
      cache
    } = _ref,
    restOptions = _objectWithoutProperties(_ref, _excluded);
  var fixes = [];
  var source = raw.replace(/^\s*<%[~=!]?\s|\s%>\s*$/g, m => {
    fixes.push(m);
    return "";
  });
  var expression = cache ? ASTCache.get(source) : undefined;
  if (!expression) {
    expression = parseAsEstreeExpression(source);
    if (cache) {
      ASTCache.set(source, expression);
    }
  }
  var attemptToVisitGlobals = precook(expression, _objectSpread(_objectSpread({}, restOptions), {}, {
    expressionOnly: true
  }));
  return {
    expression,
    attemptToVisitGlobals,
    source,
    prefix: fixes[0],
    suffix: fixes[1]
  };
}
export function isEvaluable(raw) {
  return /^\s*<%[~=]?\s/.test(raw) && /\s%>\s*$/.test(raw);
}
export function shouldAllowRecursiveEvaluations(raw) {
  return /^\s*<%~\s/.test(raw);
}
export function isSnippetEvaluation(raw) {
  return /^\s*<%[!@]=?\s/.test(raw) && /\s%>\s*$/.test(raw);
}
export function isTrackAll(raw) {
  return /^\s*<%=\s/.test(raw) && /\s%>\s*$/.test(raw);
}
export function clearExpressionASTCache() {
  ASTCache.clear();
}
//# sourceMappingURL=preevaluate.js.map